module.exports = "<article [innerHtml]=\"article\" ></article>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tw/about/p2/p2.component.html
// module id = 1023
// module chunks = 5